import {Box, Text} from '@mantine/core';
import type React from 'react';
import {MdClose} from 'react-icons/md';
import {PROFILE_IT_SKILL} from '../../../config/constants/routes';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  closePopup: () => void;
};

export const DevelopmentExperiencePromo: React.FC<Props> = ({closePopup}) => {
  const handleProfileEdit = () => {
    location.href = PROFILE_IT_SKILL;
  };

  const {isPC} = useMediaQuery();
  return (
    <>
      {isPC ? (
        <Box className="flex flex-row justify-between items-center">
          <Box className="flex flex-row text-base text-black">
            開発経験を入力することで、エンジニア向けスカウトが5倍届きます
          </Box>
          <Box className="flex flex-row items-center gap-12">
            <Box
              className="cursor-pointer flex items-center justify-center border-primary border-[1px] bg-white rounded-[8px] py-8 px-12"
              onClick={handleProfileEdit}
            >
              <Text className="text-sm text-primary font-bold">
                プロフィール編集へ
              </Text>
            </Box>
            <Box
              className="w-24 h-24 flex items-center justify-center rounded-full bg-black-3 cursor-pointer"
              onClick={closePopup}
            >
              <MdClose size={24} color="white" />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className="flex flex-row justify-between text-sm"
          onClick={handleProfileEdit}
        >
          <Text>
            開発経験を入力することで、エンジニア向けスカウトが5倍届きやすくなります。
          </Text>
          <Box
            className="flex flex-row text-primary-1 items-center"
            onClick={(e) => {
              e.stopPropagation();
              closePopup();
            }}
          >
            <MdClose size={16} className="text-black-3" />
          </Box>
        </Box>
      )}
    </>
  );
};
